import React, { useEffect, useState } from "react";
import {
  fetch_service_categories,
  delete_service_category,
  export_service_categories,
} from "../../../services/admin/service_categories";
import ItemListingTable, {
  getTableUpdateCallback,
} from "../common/ItemListingTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import ShopPopup from "./ShopPopup";
import { notify_promise } from "../../../services/utils/toasts";
import ListingPageControls from "../common/ListingPageControls";

const AdminServiceCategoryListingPage = ({ pageState, setPageState }) => {

  const [service_categories, setServiceCategories] = useState([]);

  const [selectedShop, setSelectedShop] = useState(undefined);

  const [fields, setFields] = useState([]);
  const [pagination, setPagination] = useState({});

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get("search"));
  const [latestSearchQuery, setLatestSearchQuery] = useState(
    searchParams.get("search")
  );

  const [perPage, setPerPage] = useState(10);

  const apiCall = [
    fetch_service_categories,
    { page: 0, search: search ? search : "", perPage: perPage },
  ];

  const handleDelete = (id) => {
    notify_promise(
      new Promise((resolve, reject) => {
        delete_service_category([id])
          .then((res) => {
            setServiceCategories((prevPets) => {
              return prevPets.filter((p) => {
                return p.id !== id;
              });
            });
            resolve(res);
          })
          .catch(reject);
      })
    );
  };

  useEffect(() => {
    updateTableInfo(1);
  }, [latestSearchQuery, perPage]);

  useEffect(() => {
    setSearch(searchParams.get("search"));
  }, [searchParams.get("search")]);

  useEffect(() => {
    setLatestSearchQuery(search);
  }, [search]);

  const updateTableInfo = getTableUpdateCallback({
    apiCall: apiCall,
    dataSetter: setServiceCategories,
    paginationSetter: setPagination,
    fieldSetter: setFields,
    buttons: [
      {
        template: "edit",
        getRedirectURL: (id) => {
          return "/admin/service-categories/edit/:id";
        },
      },
      {
        template: "delete",
        onClick: (id) => {
          handleDelete(id);
        },
      },
    ],
  });

  return (
    <div className="page-content py-3 px-4 bg-lightgray">
      <ShopPopup shop={selectedShop} />

      <ListingPageControls
        type="service category"
        resultType="service category"
        addOnly={true}
        setSearch={setSearchParams}
        noExport={true}
        addNewLink="/admin/service-categories/add"
      />

      <ItemListingTable
        fields={fields}
        data={service_categories}
        pagination={pagination}
        updateTableInfo={updateTableInfo}
        setPerPage={setPerPage}
        perPage={perPage}
      />
    </div>
  );
};

export default AdminServiceCategoryListingPage;
